import { BundleDetailsSection } from "../../models/page-builder/bundle-details-section.modal";

export const MOCK_BUNDLE_SECTION: BundleDetailsSection = {
  type: "bundle-details",
  content: {
    bundles: [],
    headings: {
      title: "New Year Bundle! Don’t Miss Out",
      titleColor: "#000",
      subTitle: "These courses will take you further in the new year.",
      subTitleColor: "#000",
      bundleTitle: "Get All Courses Now",
      bundleTitleColor: "#000",
      bundleMsg: "Lifetime Access Only",
      bundleMsgColor: "#000",
      actualPriceColor: "#000",
      discountedPriceColor: "#000",
    },
    images: {
      showHeroImg: true,
      showPaymentOption: true,
    },
    dateBanner: {
      showBanner: true,
      textColor: "#695800",
      bgColor: "#fcd307",
      icon: "defaultIcon",
      iconAlignment: false,
      banngerName: "banner-1",
      bannerIconName: "optionIcon-1",
    },
    benefits: {
      show: true,
      items: [
        {
          title:
            "All courses have premium content and you get a lifetime access",
          subTitle:
            "Lorem ipsum dolor sit amet consectetur. Mauris nec aliquet morbi laoreet velit. Iaculis consectetur arcu enim mauris varius.",
          titleColor: "#000",
          subTitleColor: "#000",
        },
        {
          title:
            "1All courses have premium content and you get a lifetime access",
          subTitle:
            "Lorem ipsum dolor sit amet consectetur. Mauris nec aliquet morbi laoreet velit. Iaculis consectetur arcu enim mauris varius.",
          titleColor: "#000",
          subTitleColor: "#000",
        },
        {
          title:
            "2All courses have premium content and you get a lifetime access",
          subTitle:
            "Lorem ipsum dolor sit amet consectetur. Mauris nec aliquet morbi laoreet velit. Iaculis consectetur arcu enim mauris varius.",
          titleColor: "#000",
          subTitleColor: "#000",
        },
      ],
      icon: {
        enabled: true,
        svgName: "optionIcon-9",
        color: "#000",
      },
    },
    button: {
      buttonText: "Button Text",
      textColor: "#fff",
      backgroundColor: "#000",
    },
    statistics: {
      show: true,
      iconColor: "#000",
      bgColor: "#fafafa",
      textColor: "#000",
    },
  },
  design: {
    layout: "card",
    headingAlignment: "center",
    mediaAlignment: "leftRight",
    contentAlignment: "center",
    dateAlignment: "right",
    paymentOptionAlignment: "center",
    appearance: {
      cardBgColor: "#fff",
      bundleContentBgColor: "#f1f1f1",
    },
  },
};
